import { render, staticRenderFns } from "./WorkflowProgressWidget.vue?vue&type=template&id=57917b00&scoped=true&"
import script from "./WorkflowProgressWidget.vue?vue&type=script&lang=js&"
export * from "./WorkflowProgressWidget.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowProgressWidget.vue?vue&type=style&index=0&id=57917b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57917b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57917b00')) {
      api.createRecord('57917b00', component.options)
    } else {
      api.reload('57917b00', component.options)
    }
    module.hot.accept("./WorkflowProgressWidget.vue?vue&type=template&id=57917b00&scoped=true&", function () {
      api.rerender('57917b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/WorkflowProgressWidget.vue"
export default component.exports